import { render, staticRenderFns } from "./TypeComponentForm.vue?vue&type=template&id=aac803f0&"
import script from "./TypeComponentForm.vue?vue&type=script&lang=js&"
export * from "./TypeComponentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports